export default "__VITE_ASSET__BYAjrQbf__"